/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_InformationInputs */



/**
* | output |
* | --- |
* | "Information" |
*
* @param {Common_InformationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_information = /** @type {((inputs?: Common_InformationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_InformationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Information")
	if (locale === "de") return /** @type {LocalizedString} */ ("Information")
	if (locale === "it") return /** @type {LocalizedString} */ ("Informazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Информация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Información")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("情報")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जानकारी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Informação")
	return /** @type {LocalizedString} */ ("Information")
});